import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const MediaRail = ({ title, action, children }) => {
  const ref = useRef(null);

  const scrollBy = (dx) => {
    if (ref.current) ref.current.scrollBy({ left: dx, behavior: 'smooth' });
  };

  return (
    <Box sx={{ mb: 5, position: 'relative' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1.5,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {action}
      </Box>

      <Box sx={{ position: 'relative' }}>
        <IconButton
          onClick={() => scrollBy(-600)}
          size="small"
          sx={{
            position: 'absolute',
            left: -8,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
            display: { xs: 'none', md: 'flex' },
            bgcolor: (t) => (t.palette.mode === 'dark' ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.9)'),
            backdropFilter: 'blur(6px)',
            '&:hover': { bgcolor: 'background.paper' },
          }}
        >
          <ChevronLeftIcon />
        </IconButton>

        <Box
          ref={ref}
          className="scroll-rail"
          sx={{
            display: 'flex',
            gap: 1.75,
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            pb: 1,
            pr: 1,
          }}
        >
          {children}
        </Box>

        <IconButton
          onClick={() => scrollBy(600)}
          size="small"
          sx={{
            position: 'absolute',
            right: -8,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
            display: { xs: 'none', md: 'flex' },
            bgcolor: (t) => (t.palette.mode === 'dark' ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.9)'),
            backdropFilter: 'blur(6px)',
            '&:hover': { bgcolor: 'background.paper' },
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default MediaRail;
